export const aresUserTokenVerifyKey = `
-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA1oofEdKjrWDHfIIWcVh1
zNy7bpOW0Sw6q89JnvSZp3rohfT2RP/8D8MST4Asvcib6xMrNWQgoNLjljHpWPKi
Tst3X2aj3FGEC0WAM5OohkgYNBktj41XfczuD/ANpByF0JuLPaolWMjhUyS/EqNe
bNAfc5ctvlf8OTGTykwX00b1jNxCBvoT4ou8dqTOkEjvfxmRDv+MaxRICOP6PUSb
nrDaVSWjyfOJIoc4bQz/uQKcbI+F4taUrXlClX/xC7M93vFzNNSyrugRm+mXRVEp
m1+BT+PnApI4xg7r3+PIhkooT+56bj/whpmWFvUFmjXToejEkXb2msso0dPmMnad
HMaSKhjU6rxnowSYmP/3SYNQRxQdOB9E7BxdprhH0LksjEbqNNAWD++zdbQTWgB9
XHSvjUjuk/fyNOQgh4yT7aYngoN/TwGiV7D1LxG4k7uLOxkGrXJzxWZIoqOORqeR
MzoAxQRfUAc17BWdKxJjRc+jFqGWkgpKOmFQX9dIipcXFOnj2Rm2huDqHKHgyi46
d59lhFdcnmo5EiwBSqc4D8u0zVDVUivlVdLvpOzR1pLn5thoM0S9qY9UdWXkTlYg
O+igNfCR9zcmZ5MyQAJQTgSo5xOgpFFoxoKoyAWgIHx5ehXuW6wihBw0Mj44Yt7+
B6tp+qH8aMr3flqySYlhQTcCAwEAAQ==
-----END PUBLIC KEY-----
`;

export const aresUserLoginSignKey = `
-----BEGIN RSA PRIVATE KEY-----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-----END RSA PRIVATE KEY-----
`;

export const aresPublicKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA1oofEdKjrWDHfIIWcVh1
zNy7bpOW0Sw6q89JnvSZp3rohfT2RP/8D8MST4Asvcib6xMrNWQgoNLjljHpWPKi
Tst3X2aj3FGEC0WAM5OohkgYNBktj41XfczuD/ANpByF0JuLPaolWMjhUyS/EqNe
bNAfc5ctvlf8OTGTykwX00b1jNxCBvoT4ou8dqTOkEjvfxmRDv+MaxRICOP6PUSb
nrDaVSWjyfOJIoc4bQz/uQKcbI+F4taUrXlClX/xC7M93vFzNNSyrugRm+mXRVEp
m1+BT+PnApI4xg7r3+PIhkooT+56bj/whpmWFvUFmjXToejEkXb2msso0dPmMnad
HMaSKhjU6rxnowSYmP/3SYNQRxQdOB9E7BxdprhH0LksjEbqNNAWD++zdbQTWgB9
XHSvjUjuk/fyNOQgh4yT7aYngoN/TwGiV7D1LxG4k7uLOxkGrXJzxWZIoqOORqeR
MzoAxQRfUAc17BWdKxJjRc+jFqGWkgpKOmFQX9dIipcXFOnj2Rm2huDqHKHgyi46
d59lhFdcnmo5EiwBSqc4D8u0zVDVUivlVdLvpOzR1pLn5thoM0S9qY9UdWXkTlYg
O+igNfCR9zcmZ5MyQAJQTgSo5xOgpFFoxoKoyAWgIHx5ehXuW6wihBw0Mj44Yt7+
B6tp+qH8aMr3flqySYlhQTcCAwEAAQ==
-----END PUBLIC KEY-----`;

export const aresPrivateKey = `-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----`;
